<!--
 * @Author: git config user.name && git config user.email
 * @Date: 2024-04-07 17:35:44
 * @LastEditors: git config user.name && git config user.email
 * @LastEditTime: 2024-05-29 16:49:22
 * @FilePath: \官网\demo\src\components\videoJs\index.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div class="myVideo">
    <video
      style="border-radius: 6px"
      :id="`videoPlayer` + keyValue"
      class="video-js vjs-default-skin"
      controls
      playsinline
      width="500px"
      :poster="poster"
    >
      <source :src="attachmentLink" type="application/x-mpegURL" />
    </video>
  </div>
</template>

<script>
import "video.js/dist/video-js.css";
import videojs from "video.js";
export default {
  name: "xltqView",
  props: {
    //传值
    keyValue: {
      type: String,
      default: "",
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    loop: {
      type: Boolean,
      default: false,
    },
    controls: {
      type: Boolean,
      default: true,
    },
    poster: {},
    url: {},
  },
  data() {
    return {
      dp: null,
      attachmentLink: this.url,
      options: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        aspectRatio: "16:9",
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        autoplay: this.autoplay, // 设置自动播放
        muted: this.autoplay, // 设置了它为true，才可实现自动播放,同时视频也被静音（Chrome66及以上版本，禁止音视频的自动播放）
        preload: "auto", // 预加载
        controls: this.controls, // 显示播放的控件
      },
    };
  },
  components: {
    //引入模块
  },
  watch: {
    // watch擅长处理的场景：一个数据影响多个数据
  },
  computed: {
    // computed擅长处理的场景：一个数据受多个数据影响
  },
  mounted: function () {
    // 编译好的HTML挂载到页面完成后执行的事件钩子
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    // 此钩子函数中一般会做一些ajax请求获取数据进行数据初始化
    console.log("555");
    this.initPlayer();
  },
  activated: function () {
    // 狗子触发顺序最后时执行，当再次进入（前进或者后退）时，只触发activated
  },
  methods: {
    // 组件的方法
    initPlayer() {
      // 创建video.js player对象
      this.dp = videojs("videoPlayer" + this.keyValue, this.options);
      this.dp.loop(this.loop); // 设置循环播放
      var that = this;
       this.dp.on('loadeddata', function() {
            that.$emit("load")
            // 在这里可以执行其他的加载成功逻辑
        });
     
    },
  },
  beforeCreate: function () {
    // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  },
  created: function () {
    // 实例已经创建完成之后被调用。在这一步，实例已完成以下的配置：数据观测(data observer)，属性和方法的运算， watch/event 事件回调。然而，挂载阶段还没开始，el 属性目前不可见。
  },
  beforeMount: function () {
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  beforeUpdate: function () {
    // 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
  },
  updated: function () {
    // 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
    // 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。然而在大多数情况下，你应该避免在此期间更改状态，因为这可能会导致更新无限循环。
    // 该钩子在服务器端渲染期间不被调用。
  },
  beforeDestroy: function () {
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
    console.log("bef");
  },
  destroyed: function () {
    console.log("Destroyed");
    this.dp.dispose();
    // Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，所有的事件监听器会被移除，所有的子实例也会被销毁。 该钩子在服务器端渲染期间不被调用。
  },
};
</script>
<style lang="scss" scoped>
.myVideo {
  width: 100%;
  max-width: 585px;
  max-height: 337px;
  ::v-deep .video-js {
    .vjs-poster {
      overflow: hidden;
      img {
        border-radius: 6px;
        height: auto;
      }
    }
  }
}
</style>